<manage-wrapper
  *ngIf="!!activity"
  [canEditMain]="!data.readOnly"
  [topToggleText]="'ACTIVITY ' + (activity.completed ? '' : 'NOT ' ) + 'COMPLETED'"
  [topToggled]="!!activity.completed"
  [entityTitle]="activity.title"
  [noTabs]="true"
  [readOnly]="data.readOnly"
  [labels]="activity?.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [deleteTitle]="'Delete this Activity'"
  [focusTitle]="!activity.title"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  [type]="'activity'"
  [titlePlaceholder]="'Click to add an activity name'"
  [backgroundColor]="'#FFD157'"
  [dialogTitle]="'Manage Activity'"
  [canDuplicate]="false"
  (onDone)="exit()"
  (saveTitle)="updateTitle($event)"
  (onToggle)="toggleCompleted()"
  (onDelete)="delete()"
>

  <div class="activity-body">
    <div class="left-panel">
      <title-icon [title]="'Start time'" [titleIcon]="'time24'"></title-icon>
      <joi-input class="fit-content time" #timeInput [disabled]="!!data.readOnly" [placeholder]="'00:00'" [fixedWidth]="true" [autoSelect]="true" [(model)]="activity.time" [maxlength]="7" (joiChange)="updateTime()"></joi-input>

      <title-icon style="margin-top: 40px; display: block;" [title]="'Date'" [titleIcon]="'calendar'"></title-icon>
      <div>{{ data.date | date:'EEE d MMMM y' }}</div>

      <title-icon style="margin-top: 40px; display: block;" [title]="'Schedule'" [titleIcon]="'ON_SITE_SCHEDULE24'"></title-icon>
      <div *ngIf="!!data.scheduleTitle">{{ data.scheduleTitle || 'Unnamed schedule' }}</div>
      <div *ngIf="!!data.location">{{ data.location }}</div>

      <title-icon style="margin-top: 40px; display: block;" [title]="'Activity description'" [titleIcon]="'description18'"></title-icon>
      <joi-input class="description" [disabled]="!!data.readOnly" [italicPlaceholder]="true" [(model)]="activity.description" [type]="'textarea'" [returnable]="true" [placeholder]="data.readOnly ? 'No activity description' : 'Activity description...'" (joiChange)="saveActivity()"></joi-input>

      <title-icon style="margin-top: 40px; display: block;" [title]="'Files'" [titleIcon]="'attachment'"></title-icon>
      <ng-container *ngIf="!!data.readOnly">
        <file-link *ngFor="let file of activity.files"
          [file]="file"
          [onlyLink]="true"
        ></file-link>
        <div class="empty" *ngIf="!activity?.files?.length">No files.</div>
      </ng-container>

      <ng-container *ngIf="!data.readOnly">
        <file-handler
          [data]="activity"
          [showNoFilesMessage]="!activity?.files?.length"
          (dataChange)="saveFiles($event)"
        ></file-handler>
      </ng-container>
    </div>

    <div class="tagging-holder">
      <div class="bold">Tagging</div>
      <div>Tag people to this activity so it appears in their on site schedule timeline or brief.</div>
      <tag-panel
        [readOnly]="!!data.readOnly" 
        [noHeaders]="true"
        [tagData]="tagData" 
        (removeTag)="removeTag($event)" 
        (setTags)="setTags($event)"
      ></tag-panel>
    </div>
  </div>
  <hr />
  <assets style="margin-top: 20px; display: block;"
    [assetIds]="activity?.assetIds || []"
    [title]="'Activity Assets'"
    [titleIcon]="'ASSETS'"
    [entityHolderName]="'activity'" 
    [readOnly]="data.readOnly"
    (idsAdded)="addAssetIds($event)"
    (idRemoved)="removeAssetId($event)"
  ></assets>

</manage-wrapper>